/**
 * More details about DD logging API
 * https://docs.datadoghq.com/logs/log_collection/javascript/#custom-logs
 */

export const error = (message, context) => {
    window?.DD_LOGS?.logger.error(message, context);
};

export const info = (message, context) => {
    window?.DD_LOGS?.logger.info(message, context);
};

export const warn = (message, context) => {
    window?.DD_LOGS?.logger.warn(message, context);
};
